var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewardsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 14.0625V21.0625",
    stroke: "#A461D8",
    strokeWidth: 1.24375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.0007 21.0625C12.0481 21.0625 10.3486 22.2432 9.47125 23.985C9.05219 24.8168 9.65352 25.7292 10.4525 25.7292H17.5487C18.3478 25.7292 18.9491 24.8168 18.53 23.985C17.6527 22.2432 15.9532 21.0625 14.0007 21.0625Z",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.83203 5.89062H4.64753C3.49659 5.89062 2.92112 5.89063 2.56556 6.32291C2.21001 6.7552 2.31428 7.23926 2.52281 8.20739C2.92113 10.0566 3.78509 11.6813 4.95575 12.8906",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.168 5.89062H23.3525C24.5034 5.89062 25.0789 5.89063 25.4344 6.32291C25.79 6.7552 25.6857 7.23926 25.4772 8.20739C25.0789 10.0566 24.2149 11.6813 23.0443 12.8906",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.0007 14.0651C18.511 14.0651 22.1673 10.4287 22.1673 5.94302C22.1673 5.82539 22.1648 5.70835 22.1599 5.59194C22.11 4.42617 22.0851 3.8433 21.295 3.12086C20.5049 2.39844 19.6295 2.39844 17.8787 2.39844H10.1226C8.37179 2.39844 7.49639 2.39844 6.70632 3.12086C5.91625 3.84328 5.89133 4.42617 5.84147 5.59194C5.83649 5.70835 5.83398 5.82539 5.83398 5.94302C5.83398 10.4287 9.49033 14.0651 14.0007 14.0651Z",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsIcon);
export default __webpack_public_path__ + "static/media/rewards-icon.059c5dca889f8304984d3ed40ec3bc4b.svg";
export { ForwardRef as ReactComponent };